import { useRef } from 'react'
import { useDateSegment } from 'react-aria'
import { DateFieldState, DateSegment as IDateSegment } from 'react-stately'
import { cn } from '@/lib/utils'

/* 
This component supports a shadcn integration for a date-time-picker and was written by @uncvrd https://github.com/uncvrd/shadcn-ui-date-time-picker
Original issue: https://github.com/shadcn-ui/ui/issues/255
TODO: replace this component with an official shadcn datepicker after this issue is closed & supported by the library
*/

interface DateSegmentProps {
  segment: IDateSegment
  state: DateFieldState
}

function DateSegment({ segment, state }: DateSegmentProps) {
  const ref = useRef(null)

  const {
    segmentProps: { ...segmentProps }
  } = useDateSegment(segment, state, ref)

  return (
    <div
      {...segmentProps}
      ref={ref}
      className={cn(
        'focus:bg-primary-container focus:text-accent-foreground focus:rounded-[2px] focus:outline-none',
        segment.type !== 'literal' ? 'px-[1px]' : '',
        segment.isPlaceholder ? 'text-muted-foreground' : ''
      )}
    >
      {segment.text}
    </div>
  )
}

export { DateSegment }
